// checkPermissionsFunc.js
export default function checkPermissions(
  targetPermissions,
  element,
  insteadPage,
  mode = "jsx" // "jsx" (القديم) أو "boolean" (الجديد)
) {
  const user = JSON.parse(window.localStorage.getItem("user"));
  const permissionsList = user?.permissions || [];
  const userRoleName = user?.roleName?.toLowerCase();

  const isSuperAdmin = userRoleName === "super admin";

  const hasPermission = (() => {
    if (isSuperAdmin) return true;

    if (Array.isArray(targetPermissions)) {
      return targetPermissions.some((perm) =>
        permissionsList.some(
          (p) => p.name.toLowerCase() === perm.toLowerCase()
        )
      );
    }

    return permissionsList.some(
      (p) => p.name.toLowerCase() === targetPermissions?.toLowerCase()
    );
  })();

  // 🔹 الوضع الجديد (boolean)
  if (mode === "boolean") {
    return hasPermission;
  }

  // 🔹 الوضع القديم (JSX)
  if (hasPermission) {
    return element;
  } else {
    return insteadPage || null;
  }
}
